import HubLeadCTA from "@/components/HubLeadCTA";
import NaatiClusterLinks from "@/components/NaatiClusterLinks";
import { createFileRoute, Link } from "@tanstack/react-router";
import { canonicalAndHreflangEn, ctaDesc, ctaTitle } from "@/lib/seo";
import { NAATI_VISA_SUBCLASSES } from "@/data/naati-visa-subclasses";

const TITLE = "NAATI Certified Translation by Australian Visa Subclass | NYC";
const DESC = "Select your Australian visa (Partner 820/309, Skilled 189/190/491, TSS 482, Student 500, Graduate 485. Ask us anything — real experts reply within minutes.";

export const Route = createFileRoute("/en/translate/naati/visa/")({
  head: () => ({
    meta: [
      { title: ctaTitle(TITLE, "/en/translate/naati/visa/index", "en")}, { name: "description", content: ctaDesc(DESC, "/en/translate/naati/visa/index", "en")},
      { property: "og:title", content: ctaTitle(TITLE, "/en/translate/naati/visa/index", "en")}, { property: "og:description", content: ctaDesc(DESC, "/en/translate/naati/visa/index", "en")},
      { property: "og:url", content: "https://nyclanguageinstitute.com/en/translate/naati/visa" },
    ],
    links: canonicalAndHreflangEn("/en/translate/naati/visa", "/translate/naati/visa"),
    scripts: [{ type: "application/ld+json", children: JSON.stringify({ "@context":"https://schema.org","@type":"CollectionPage","@id":"https://nyclanguageinstitute.com/en/translate/naati/visa#collection","url":"https://nyclanguageinstitute.com/en/translate/naati/visa","name":"NAATI Certified Translation by Australian Visa Subclass","inLanguage":"en","numberOfItems":NAATI_VISA_SUBCLASSES.length }) }],
  }),
  component: () => (
    <main className="min-h-screen bg-background">
      <section className="bg-gradient-to-b from-amber-100/60 to-background px-4 pt-16 pb-10">
        <div className="mx-auto max-w-5xl">
          <span className="inline-block rounded-full bg-amber-500/15 px-3 py-1 text-xs font-bold text-amber-700">NAATI × Australian Visa Matrix</span>
          <h1 className="mt-3 text-3xl font-extrabold sm:text-5xl">NAATI translation for 16 Australian visa subclasses</h1>
          <p className="mt-4 max-w-3xl text-lg text-muted-foreground">{DESC}</p>
        </div>
      </section>
      <section className="mx-auto max-w-5xl px-4 py-10">
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {NAATI_VISA_SUBCLASSES.map((v) => (
            <Link key={v.slug} to="/en/translate/naati/visa/$subclass" params={{ subclass: v.slug }}
              className="group rounded-2xl border border-slate-200 bg-white p-5 transition hover:-translate-y-0.5 hover:border-amber-400 hover:shadow-md">
              <div className="text-[11px] font-bold uppercase tracking-widest text-amber-700">Subclass {v.code}</div>
              <div className="mt-1 font-display text-lg font-extrabold text-navy-deep group-hover:text-amber-600">{v.nameEn}</div>
              <div className="mt-1 text-xs text-slate-500">{v.streamEn}</div>
              <div className="mt-3 text-xs text-slate-600">Processing: {v.processingTimeEn}</div>
              <div className="mt-1 text-xs text-slate-600">DHA fee: AUD {v.govFeeAud.toLocaleString()}</div>
            </Link>
          ))}
        </div>
      </section>
      <NaatiClusterLinks />
    <HubLeadCTA locale="en" service="NAATI" />
      </main>
  ),
});
